import { facilityStayAction } from '../../actions/constant';

const { SUCCESS_UPDATE_FACILITY_STAY, FAILURE_UPDATE_FACILITY_STAY, RESET_UPDATE_FACILITY_STAY,UPDATE_FACILITY_LOADING } =
  facilityStayAction;

const initialState: object = {
  useFacilityStayUpdated: false,
  response: null,
  loading:false,
};

export const updateFacilityStayReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case SUCCESS_UPDATE_FACILITY_STAY: {
      return {
        ...state,
        useFacilityStayUpdated: true,
        response: action.payload,
        loading:false,
      };
    }

    case FAILURE_UPDATE_FACILITY_STAY:
      return {
        ...state,
        useFacilityStayUpdated: false,
        response: action.payload,
        loading:false,
      };

      case UPDATE_FACILITY_LOADING:
      return {
        ...state,
        loading:true,
      };

    case RESET_UPDATE_FACILITY_STAY:
      return initialState;

    default:
      return state;
  }
};
